import { createSelector } from "redux-starter-kit";

export default createSelector(
  ["signup.steps"],
  step => step
);
